export function StreamingCursor() {
  return (
    <span
      className="cx-streaming-cursor animate-cx-blink inline-block ml-0.5 align-text-bottom"
      aria-hidden="true"
    />
  );
}
